import React from "react"
import { cn } from "../../../../../../lib"
import { motion, AnimatePresence } from "framer-motion"

const CircularCheckbox = ({ children, checked = false, onChange, className }) => {
  return (
    <div
      className={cn(
        "flex items-center cursor-pointer",
        !children && "justify-center mb-0",
        className
      )}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange ?? (() => {})}
        className="sr-only"
      />
      <motion.div
        className={`
      w-4 h-4
      rounded-full
      border-2
      flex items-center justify-center
      cursor-pointer
      ${checked ? "bg-second-success border-second-success" : "bg-white border-gray-300"}
    `}
        whileTap={{ scale: 0.85 }}
        transition={{ type: "spring", stiffness: 300, damping: 20 }}
      >
        <AnimatePresence>
          {checked && (
            <motion.svg
              className="w-3 h-3 text-white shrink-0"
              viewBox="0 0 20 20"
              fill="currentColor"
              initial={{ scale: 0, rotate: -45, opacity: 0 }}
              animate={{ scale: 1, rotate: 0, opacity: 1 }}
              exit={{ scale: 0, rotate: 45, opacity: 0 }}
              transition={{ type: "spring", stiffness: 500, damping: 25 }}
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </motion.svg>
          )}
        </AnimatePresence>
      </motion.div>
      {children && children}
    </div>
  )
}

export default CircularCheckbox
